export default function Services()
{
  const panelResources = (BEditor.AdminPanel ? BEditor.AdminPanel.getPanelResources() : null),
        adminResources = (panelResources ? panelResources.AdminEditor : {});


  this.getThemeStyles = (onSuccess, onError) =>
  {
    var isTestEnv = (typeof __TEST__ === 'boolean');

    if (isTestEnv)
    {
      return;
    }

    BEditor.ajax.request(
    {
      url: '/Sys/Editor/GetThemeStyles',
      type: BEditor.ajax.Types.GET,
      responseType: BEditor.ajax.ResponseTypes.JSON,
      onSuccess,
      onError
    });
  };


  this.getTidyContent = (url, html, onSuccess, onError) =>
  {
    BEditor.ajax.request(
    {
      url: adminResources.tidyServiceUrl || '/Sys/Editor/GetCleanWithTidy/',
      type: BEditor.ajax.Types.POST,
      responseType: BEditor.ajax.ResponseTypes.JSON,
      data: JSON.stringify({ content: html }),
      dataType: BEditor.ajax.ResponseTypes.JSON,
      onSuccess,
      onError
    });
  };


  this.loadEditorSiteStructure = (onSuccess, onError) =>
  {
    BEditor.ajax.request(
    {
      url: adminResources.GetInsertLinkDialogSiteStructure || '/Sys/Editor/GetInsertLinkDialogSiteStructure',
      type: BEditor.ajax.Types.GET,
      responseType: BEditor.ajax.ResponseTypes.JSON,
      onSuccess,
      onError
    });
  };
}